import AnimatedEl from '@/lib/motion';
import { Target } from './constants/targets';
import { ScraperHeaderTargetOption } from './ScraperHeaderTargetOption';

type Props = {
  targets: Target[];
  selectedTarget: Target;
  handleTargetSelect: (target: Target) => void;
};

export const ScraperHeaderTargetOptions = ({
  targets,
  selectedTarget,
  handleTargetSelect,
}: Props) => {
  return (
    <AnimatedEl
      el='ul'
      initial='closed'
      animate='open'
      exit='closed'
      variants={listVariants}
      className='max-h-80 overflow-y-auto'
    >
      {targets.map((target) => (
        <ScraperHeaderTargetOption
          key={target.name}
          target={target}
          isSelected={target.name === selectedTarget.name}
          handleSelect={handleTargetSelect}
        />
      ))}
    </AnimatedEl>
  );
};

const listVariants = {
  open: {
    transition: { staggerChildren: 0.025 },
  },
};
